// // let googleFb = function (id){
// //     debugger
// // }
// let googleFb = function name(FbqIdList, type = 'index') {
// debugger
// }
// debugger
// let googFb = function(){
//     debugger
// }
// export function charu (a){

// }
// window.dataLayer = window.dataLayer || [];
// function gtag(){dataLayer.push(arguments);}
// gtag('js', new Date());

// gtag('config', 'AW-454357537');
export default{
    //时间戳转换为正常时间格式
    getId:function(id){
        $('body').append(`<script async src="https://www.googletagmanager.com/gtag/js?id=${id}"></script>`);
    },
    // 购买
    purchase(id,events){
        gtag('event', 'conversion', {'send_to': `${id}/${events}`,'transaction_id': ''});
    },
    // 添加到购物车
    addTocar(id,events){
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('event', 'conversion', {'send_to': `${id}/${events}`});
    },
    // // 网页浏览
    // browse(){
    //     gtag('event', 'conversion', {'send_to': 'AW-454357537/QLn2CKXB4u4BEKHk09gB'});
    // },
    // // 提交潜在客户表单
    // potential(){
    //     gtag('event', 'conversion', {'send_to': 'AW-454357537/4RdCCMD41e4BEKHk09gB'});
    // },
    // // 开始结帐
    // checkOut(){
    //     gtag('event', 'conversion', {'send_to': 'AW-454357537/6MxxCL_61e4BEKHk09gB'});
    // }

  }


// WEBPACK FOOTER //
// ./src/google/google.js